import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AutoActionService } from '../../service/auto-action.service';
import { ToolbarMenuComponent } from '../../../common/component/toolbar-menu/toolbar-menu.component';
import { DashboardHeaderComponent } from '../dashboard-header/dashboard-header.component';
import { UserAccountService } from '../../../common/service/user-account.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardComponent implements OnInit {
  @ViewChild('header') header: DashboardHeaderComponent;

  constructor(
    private readonly _autoActionService: AutoActionService,
    private readonly _accountService: UserAccountService
  ) {}

  @ViewChild(ToolbarMenuComponent) toolbarButtons: ToolbarMenuComponent;

  public isAdmin$ = this._accountService.isAdmin$;

  ngOnInit() {
    this._autoActionService.sendParameterRequest();
  }

  onClick(e: MouseEvent) {
    this.toolbarButtons?.closeMenus();
  }
}
